import { render, staticRenderFns } from "./CreatePermission.vue?vue&type=template&id=4f750b4d&"
import script from "./CreatePermission.vue?vue&type=script&lang=js&"
export * from "./CreatePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports